import React from 'react';

import {service as SpeciesTypeService} from "../../../Services/SpeciesTypeService";
import {service as SpeciesNativityService} from "../../../Services/SpeciesNativityService";
import {service as SpeciesInvasivityService} from "../../../Services/SpeciesInvasivityService";

import {StandardModelViewerRecordRenderer} from "../RecordRenderers/StandardModelViewerRecordRenderer";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {SpeciesListSpeciesFields} from './SpeciesListSpeciesFields';
import {SpeciesListSpeciesFieldServices} from "./SpeciesListSpeciesFieldServices";

export const SpeciesListSpeciesModelViewerRecordRenderer = (props) => {

    usePrimeCache([SpeciesTypeService, SpeciesNativityService, SpeciesInvasivityService])

    const { CustomData, FieldDef, Data } = props;

    const getOriginalValue = () => {
        const originalValueKey = SpeciesListSpeciesFields?.[FieldDef?.key] ?? FieldDef?.key;
        return CustomData?.Species?.[originalValueKey] ?? null;
    }

    const getOriginalDisplayValue = () => {
        const value = getOriginalValue?.();
        return SpeciesListSpeciesFieldServices[FieldDef?.key]?.CachedTitleById(value) ?? value;
    }

    const originalValue = getOriginalValue?.();
    const originalDisplayValue = getOriginalDisplayValue?.();
    const value = FieldDef?.getter?.(Data);
    const hasMutated = (originalValue && value && originalValue != value);

    return <StandardModelViewerRecordRenderer
        {...props}
        tdClassName={hasMutated ? 'sb-species-list-species-mutated' : ''}
        defaultValue={originalValue}
        subText={hasMutated ? originalDisplayValue : null}
    />
}
